import type { ComponentType } from 'react';
import { TableCell, TableRow } from '@/components/ui/table';

interface TableEmptyRowProps {
  /** Number of table columns, so the message spans the full width. */
  columnCount: number;
  icon: ComponentType<{ className?: string }>;
  title: string;
  hint?: string;
}

/** "No data" message shown inside the table body, so the column headers stay visible. */
export function TableEmptyRow({ columnCount, icon: Icon, title, hint = 'Try adjusting your search or filters.' }: TableEmptyRowProps) {
  return (
    <TableRow className="hover:bg-transparent">
      <TableCell colSpan={columnCount} className="h-72 text-center">
        <div className="flex flex-col items-center justify-center">
          <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-gray-100">
            <Icon className="h-6 w-6 text-gray-400" />
          </div>
          <p className="text-sm font-medium text-gray-700">{title}</p>
          <p className="mt-1 text-sm text-gray-500">{hint}</p>
        </div>
      </TableCell>
    </TableRow>
  );
}
